import { Radio } from "@mantine/core";
import classes from "./radio.module.css";
export const radioProps = Radio.extend({
    classNames: classes,
});
